import styled from 'styled-components';
import { SECONDARY_LIGHT, WHITE, SECONDARY_EXTRA_LIGHT, PRIMARY_EXTRA_LIGHT, PRIMARY_LIGHT, PRIMARY } from '../../utils/colors';

export const QuantityBox = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 12px;
  padding: 8px;
  min-width: 135px;
  justify-content: space-between;
`;

export const QuantityButton = styled.button`
  background-color: ${PRIMARY};
  color: ${WHITE};
  border: none;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
  opacity: 0.8;
  transition: background-color 0.3s ease-in, color 0.3s ease-in;

  &:hover {
    background-color: ${PRIMARY_LIGHT};
    transition: background-color 0.3s ease-out, color 0.3s ease-out;
  }
`;

export const Count = styled.span`
  padding: 0 8px;
  font-size: 16px;
  min-width: 20px;
  text-align: center;
  font-family: 'FigtreeBold', sans-serif;
`;